import { TextareaAutosize } from '@mui/material'
import { useEffect, useState } from 'react'
import TitleQuality from '../TitleQuality'
import { useDispatch, useSelector } from 'react-redux'
import { DocumentState } from '../../../redux/types'
import { selectDocumentState, setTitle } from '../../../redux/docSlice'
import { useDocId } from '../../../hooks/docID'
import { CONSTANTS } from '../../../constants'

const TitleStep = () => {
	const [displayedPlaceholder, setDisplayedPlaceholder] = useState('')
	const placeholderText = 'Type your topic here...'
	const dispatch = useDispatch()
	const docId = useDocId()
	const documentState: DocumentState = useSelector((state) => selectDocumentState(state, docId))
	const [topicInputFocused, setTopicInputFocused] = useState(false)

	useEffect(() => {
		let index = 0
		const interval = setInterval(() => {
			if (index < placeholderText.length) {
				setDisplayedPlaceholder((prev) => prev + placeholderText[index])
				index++
			} else {
				clearInterval(interval)
			}
		}, 30)

		return () => clearInterval(interval) // Cleanup on unmount
	}, [])

	useEffect(() => {
		setDisplayedPlaceholder('')
	}, [])

	return (
		<>
			<div className="flex flex-col gap-3">
				<TextareaAutosize
					placeholder={displayedPlaceholder}
					className={`w-full resize-none outline-none border-2 transition-colors focus:border-gray-600 border-gray-300 px-2 py-2 md:py-4 md:px-4 rounded-xl ${
						documentState.title?.length > 100 ? 'md:text-2xl text-lg' : 'md:text-2xl text-xl'
					} font-medium`}
					autoFocus
					onFocus={() => {
						setTopicInputFocused(true)
					}}
					onBlur={() => {
						setTopicInputFocused(false)
					}}
					onChange={(e) => {
						dispatch(setTitle({ docID: docId, title: e.target.value }))
					}}
					minRows={3}
					id="topicHeader"
					maxRows={topicInputFocused ? undefined : 3}
					maxLength={CONSTANTS.MAX_TOPIC_LENGTH}
					value={documentState.title}
				/>
				<TitleQuality topic={documentState.title} />
			</div>
			<div className="flex flex-col gap-2 mt-5">
				<div className="text-lg font-semibold mb-1">Suggested Topics:</div>
				<div className="flex gap-2 flex-wrap md:flex-nowrap">
					{[
						'Why the Battle of Midway was a turning point in WW2',
						'The Influence of Arts Education on Culture, Society, and Population Happiness',
						'The Experience That Taught Me How Looks Could Be Deceiving',
					].map((topic, i) => (
						<div
							key={i}
							className="rounded-lg px-3 py-2 font-semibold cursor-pointer hover:bg-gray-50 border border-gray-300 text-gray-700 hover:text-gray-900"
							onClick={() => dispatch(setTitle({ docID: docId, title: topic }))}
						>
							{topic}
						</div>
					))}
				</div>
			</div>
		</>
	)
}

export default TitleStep
